import { render } from "./EventForm.vue?vue&type=template&id=741d5638&scoped=true"
import script from "./EventForm.vue?vue&type=script&lang=ts"
export * from "./EventForm.vue?vue&type=script&lang=ts"

import "./EventForm.vue?vue&type=style&index=0&id=741d5638&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-741d5638"

export default script